import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { ForwardedRef, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

export type IconProps = {
  className?: string | undefined
} & Omit<FontAwesomeIconProps, 'className'>

export const Icon = forwardRef(
  function Icon (props: IconProps, ref: ForwardedRef<SVGSVGElement>) {
    return (
      <FontAwesomeIcon
        {...props}
        ref={ref}
        className={twMerge('core-icon', props.className)}
      />
    )
  }
)
